import { checkIfWebP } from '@giphy/js-util'
import 'shared/trackjs'
import { googleAnalyticsEvent } from 'shared/util/analytics'
import renderMedia from './components/media'
import './main.css'

global.isMobile = 'ontouchstart' in window || navigator.maxTouchPoints
global.isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream

global.trackEvent = (action, label) => {
    googleAnalyticsEvent({
        category: 'GIF Landing',
        action,
        label,
    })
}

global.Giphy = global.Giphy || {}
global.Giphy.renderMediaLanding = (el, data) => {
    checkIfWebP.then((isWebpSupported) => {
        el.innerHTML = renderMedia(data, isWebpSupported)
    })
}
